import { useSnowplowTracking, useTranslation } from '@eti/providers';
import { useState } from 'react';
import CFCInfoCard from '../../../common/cfc-info-card/CFCInfoCard';
import CFCInfoDrawer from '../../../common/cfc-info-drawer/CFCInfoDrawer';

const CFCInformationCard = () => {
  const { t } = useTranslation();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const handleCardClick = () => {
    setDrawerOpen(true);
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Payment',
        action: 'Click',
        label: 'Booking process information',
        property: 'Ryanair',
      });
    }
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };
  return (
    <div>
      <CFCInfoCard
        contentText={t('Payment.Ryanair.InfoCard.Description')}
        data-testid="cfc-info-card-payment-methods"
        handleLinkButtonClick={handleCardClick}
        headingLevel={2}
        linkButtonText={t('Payment.Ryanair.InfoCard.Link.Text')}
        title={t('Payment.Ryanair.InfoCard.Title')}
      />
      <CFCInfoDrawer handleCloseDrawer={closeDrawer} isDrawerOpen={isDrawerOpen} />
    </div>
  );
};

export default CFCInformationCard;
